import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'jquery/dist/jquery.min.js'
import { installFirebaseUsageMonitoring } from './observability/firebaseUsage'

// Register once before mounting the application. All components import the
// same Axios singleton, so their Firebase REST requests pass these interceptors.
installFirebaseUsageMonitoring(router)

// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// createApp(App).use(BootstrapVue);
// createApp(App).use(IconsPlugin);


// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

createApp(App).use(router).mount('#app')
